export enum PromotionEnumKey {
    RegularRate = 'REGULARRATE',
    Promotion_SpecialRate = 'PROMOTIONALRATE',
    CorporateRate = 'CORPORATERATE',
    AgencyRate = 'AGENCYRATE',
    GovernmentMilitaryRate = 'GOVERNMIL',
    SeniorCitizenRate = 'SENIORCITIZEN',
    CAA_AAA_Rate = 'AAA',
    contractedRate = 'CONTRACTEDRATE'
}